import { aeFlagContent } from 'src/ui/assets/icons/flags/content/aeFlagContent';
import { amFlagContent } from 'src/ui/assets/icons/flags/content/amFlagContent';
import { arFlagContent } from 'src/ui/assets/icons/flags/content/arFlagContent';
import { atFlagContent } from 'src/ui/assets/icons/flags/content/atFlagContent';
import { auFlagContent } from 'src/ui/assets/icons/flags/content/auFlagContent';
import { azFlagContent } from 'src/ui/assets/icons/flags/content/azFlagContent';
import { beFlagContent } from 'src/ui/assets/icons/flags/content/beFlagContent';
import { bgFlagContent } from 'src/ui/assets/icons/flags/content/bgFlagContent';
import { brFlagContent } from 'src/ui/assets/icons/flags/content/brFlagContent';
import { bwFlagContent } from 'src/ui/assets/icons/flags/content/bwFlagContent';
import { caFlagContent } from 'src/ui/assets/icons/flags/content/caFlagContent';
import { chFlagContent } from 'src/ui/assets/icons/flags/content/chFlagContent';
import { clFlagContent } from 'src/ui/assets/icons/flags/content/clFlagContent';
import { cnFlagContent } from 'src/ui/assets/icons/flags/content/cnFlagContent';
import { coFlagContent } from 'src/ui/assets/icons/flags/content/coFlagContent';
import { crFlagContent } from 'src/ui/assets/icons/flags/content/crFlagContent';
import { cyFlagContent } from 'src/ui/assets/icons/flags/content/cyFlagContent';
import { czFlagContent } from 'src/ui/assets/icons/flags/content/czFlagContent';
import { deFlagContent } from 'src/ui/assets/icons/flags/content/deFlagContent';
import { dkFlagContent } from 'src/ui/assets/icons/flags/content/dkFlagContent';
import { dzFlagContent } from 'src/ui/assets/icons/flags/content/dzFlagContent';
import { ecFlagContent } from 'src/ui/assets/icons/flags/content/ecFlagContent';
import { eeFlagContent } from 'src/ui/assets/icons/flags/content/eeFlagContent';
import { engFlagContent } from 'src/ui/assets/icons/flags/content/engFlagContent';
import { esFlagContent } from 'src/ui/assets/icons/flags/content/esFlagContent';
import { etFlagContent } from 'src/ui/assets/icons/flags/content/etFlagContent';
import { euFlagContent } from 'src/ui/assets/icons/flags/content/euFlagContent';
import { frFlagContent } from 'src/ui/assets/icons/flags/content/frFlagContent';
import { gbFlagContent } from 'src/ui/assets/icons/flags/content/gbFlagContent';
import { grFlagContent } from 'src/ui/assets/icons/flags/content/grFlagContent';
import { hkFlagContent } from 'src/ui/assets/icons/flags/content/hkFlagContent';
import { hrFlagContent } from 'src/ui/assets/icons/flags/content/hrFlagContent';
import { huFlagContent } from 'src/ui/assets/icons/flags/content/huFlagContent';
import { idFlagContent } from 'src/ui/assets/icons/flags/content/idFlagContent';
import { ieFlagContent } from 'src/ui/assets/icons/flags/content/ieFlagContent';
import { ilFlagContent } from 'src/ui/assets/icons/flags/content/ilFlagContent';
import { inFlagContent } from 'src/ui/assets/icons/flags/content/inFlagContent';
import { internationalFlagContent } from 'src/ui/assets/icons/flags/content/internationalFlagContent';
import { internationalInverseFlagContent } from 'src/ui/assets/icons/flags/content/internationalInverseFlagContent';
import { isFlagContent } from 'src/ui/assets/icons/flags/content/isFlagContent';
import { itFlagContent } from 'src/ui/assets/icons/flags/content/itFlagContent';
import { joFlagContent } from 'src/ui/assets/icons/flags/content/joFlagContent';
import { jpFlagContent } from 'src/ui/assets/icons/flags/content/jpFlagContent';
import { krFlagContent } from 'src/ui/assets/icons/flags/content/krFlagContent';
import { lkFlagContent } from 'src/ui/assets/icons/flags/content/lkFlagContent';
import { ltFlagContent } from 'src/ui/assets/icons/flags/content/ltFlagContent';
import { lvFlagContent } from 'src/ui/assets/icons/flags/content/lvFlagContent';
import { mtFlagContent } from 'src/ui/assets/icons/flags/content/mtFlagContent';
import { mxFlagContent } from 'src/ui/assets/icons/flags/content/mxFlagContent';
import { nirFlagContent } from 'src/ui/assets/icons/flags/content/nirFlagContent';
import { nlFlagContent } from 'src/ui/assets/icons/flags/content/nlFlagContent';
import { noFlagContent } from 'src/ui/assets/icons/flags/content/noFlagContent';
import { nzFlagContent } from 'src/ui/assets/icons/flags/content/nzFlagContent';
import { peFlagContent } from 'src/ui/assets/icons/flags/content/peFlagContent';
import { phFlagContent } from 'src/ui/assets/icons/flags/content/phFlagContent';
import { pkFlagContent } from 'src/ui/assets/icons/flags/content/pkFlagContent';
import { plFlagContent } from 'src/ui/assets/icons/flags/content/plFlagContent';
import { ptFlagContent } from 'src/ui/assets/icons/flags/content/ptFlagContent';
import { pyFlagContent } from 'src/ui/assets/icons/flags/content/pyFlagContent';
import { qaFlagContent } from 'src/ui/assets/icons/flags/content/qaFlagContent';
import { roFlagContent } from 'src/ui/assets/icons/flags/content/roFlagContent';
import { scoFlagContent } from 'src/ui/assets/icons/flags/content/scoFlagContent';
import { seFlagContent } from 'src/ui/assets/icons/flags/content/seFlagContent';
import { sgFlagContent } from 'src/ui/assets/icons/flags/content/sgFlagContent';
import { siFlagContent } from 'src/ui/assets/icons/flags/content/siFlagContent';
import { thFlagContent } from 'src/ui/assets/icons/flags/content/thFlagContent';
import { trFlagContent } from 'src/ui/assets/icons/flags/content/trFlagContent';
import { uaFlagContent } from 'src/ui/assets/icons/flags/content/uaFlagContent';
import { ugFlagContent } from 'src/ui/assets/icons/flags/content/ugFlagContent';
import { usFlagContent } from 'src/ui/assets/icons/flags/content/usFlagContent';
import { uyFlagContent } from 'src/ui/assets/icons/flags/content/uyFlagContent';
import { veFlagContent } from 'src/ui/assets/icons/flags/content/veFlagContent';
import { walFlagContent } from 'src/ui/assets/icons/flags/content/walFlagContent';
import { zaFlagContent } from 'src/ui/assets/icons/flags/content/zaFlagContent';

export const INTERNATIONAL_FLAG_CODE = 'international';

// ISO 3166-1 alpha-2 codes, plus pseudo-codes for UK home nations (eng/sco/wal/nir)
// and 'eu'/'international' for continental and fallback competitions.
export const flagContents: Record<string, JSX.Element> = {
    ae: aeFlagContent,
    ar: arFlagContent,
    at: atFlagContent,
    au: auFlagContent,
    be: beFlagContent,
    br: brFlagContent,
    ca: caFlagContent,
    ch: chFlagContent,
    cl: clFlagContent,
    cn: cnFlagContent,
    co: coFlagContent,
    cr: crFlagContent,
    cy: cyFlagContent,
    cz: czFlagContent,
    de: deFlagContent,
    dk: dkFlagContent,
    eng: engFlagContent,
    es: esFlagContent,
    eu: euFlagContent,
    fr: frFlagContent,
    gb: gbFlagContent,
    gr: grFlagContent,
    hr: hrFlagContent,
    hu: huFlagContent,
    id: idFlagContent,
    ie: ieFlagContent,
    in: inFlagContent,
    international: internationalFlagContent,
    'international-inverse': internationalInverseFlagContent,
    is: isFlagContent,
    it: itFlagContent,
    jo: joFlagContent,
    jp: jpFlagContent,
    kr: krFlagContent,
    lk: lkFlagContent,
    lt: ltFlagContent,
    mx: mxFlagContent,
    nir: nirFlagContent,
    nl: nlFlagContent,
    no: noFlagContent,
    nz: nzFlagContent,
    pe: peFlagContent,
    ph: phFlagContent,
    pk: pkFlagContent,
    pl: plFlagContent,
    pt: ptFlagContent,
    py: pyFlagContent,
    qa: qaFlagContent,
    ro: roFlagContent,
    sco: scoFlagContent,
    sg: sgFlagContent,
    si: siFlagContent,
    th: thFlagContent,
    tr: trFlagContent,
    us: usFlagContent,
    uy: uyFlagContent,
    ve: veFlagContent,
    wal: walFlagContent,
    za: zaFlagContent,
    am: amFlagContent,
    az: azFlagContent,
    bg: bgFlagContent,
    bw: bwFlagContent,
    dz: dzFlagContent,
    ec: ecFlagContent,
    ee: eeFlagContent,
    et: etFlagContent,
    hk: hkFlagContent,
    il: ilFlagContent,
    lv: lvFlagContent,
    mt: mtFlagContent,
    se: seFlagContent,
    ua: uaFlagContent,
    ug: ugFlagContent,
};
